import styled from "@emotion/styled";

export const LeadAssignmentsPageToolbarContainer = styled.div({
	display: "flex",
	width: "100%",
	justifyContent: "space-between",
	alignItems: "center",
	flexWrap: "wrap",
	gap: "16px"
});

export const LeadAssignmentsPageFilterContainer = styled.div(({ theme }) => ({
	display: "flex",
	alignItems: "center",
	gap: "8px",
	[theme.breakpoints.down("md")]: {
		flexDirection: "column",
		alignItems: "flex-start",
		gap: "16px",
		width: "100%",
		"& .MuiAutocomplete-root": {
			width: "100%"
		}
	}
}));
